import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';

@Component({
    selector: 'button[sonaGoogleButton]',
    imports: [
        TranslateModule
    ],
    templateUrl: './google-button.component.html',
    styleUrl: './google-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    hostDirectives: [{
            directive: HlmButtonDirective,
            inputs: ['class', 'size', 'variant']
        }]
})
export class SonaGoogleButtonComponent {
}
